// Single source of truth for analytics events.
// Calling these is safe when no analytics provider is loaded — each platform call is guarded.

export function trackEvent(name, params = {}) {
  // GA4
  if (typeof window.gtag === "function") {
    try { window.gtag("event", name, params); } catch { /* noop */ }
  }
  // LinkedIn Insight conversion tracking is configured in Campaign Manager,
  // but we can also fire a custom event ID once provided per event in env.
  const liMap = window.__renviaLiConversionMap || {};
  if (liMap[name] && typeof window.lintrk === "function") {
    try { window.lintrk("track", { conversion_id: liMap[name] }); } catch { /* noop */ }
  }
  // Microsoft Clarity custom tags (string only)
  if (typeof window.clarity === "function") {
    try { window.clarity("set", name, JSON.stringify(params).slice(0, 200)); } catch { /* noop */ }
  }
}

export function trackPageView(path) {
  if (typeof window.gtag === "function" && process.env.REACT_APP_GA4_ID) {
    window.gtag("event", "page_view", {
      page_path: path,
      send_to: process.env.REACT_APP_GA4_ID,
    });
  }
}
